import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { INSTRUMENTS_QUERY_KEY } from "./useInstruments";

type UpdateInstrumentBody = components["schemas"]["UpdateInstrumentBody"];
type InstrumentResponse = components["schemas"]["InstrumentResponse"];

export type UpdateInstrumentVariables = {
  instrumentId: string;
  body: UpdateInstrumentBody;
};

export function useUpdateInstrument() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<InstrumentResponse, Error, UpdateInstrumentVariables>({
    mutationFn: async ({ instrumentId, body }) => {
      const { data, error } = await client.PATCH(
        "/api/instruments/{instrument_id}",
        {
          params: { path: { instrument_id: instrumentId } },
          body,
        },
      );
      if (error !== undefined) {
        throw new Error(`Failed to update instrument ${instrumentId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: INSTRUMENTS_QUERY_KEY });
    },
  });
}
